import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, FlexColumn, Spinner, Suspense, showSuccessToast } from 'core/components';
import ModelSettings from 'app/views/settings/ai/ModelSettings';
import { FormActions, FormComponent } from 'core/form';
import SettingsPanelHeading from 'app/views/settings/ai/SettingsPanelHeading';

@inject('$ai', '$moduleConfig', '$credentials')
@observer
class ModelsAndCredentials extends Component {
  state = { loading: true };

  get fields() {
    const { $ai } = this.props;
    const fields = {};
    $ai.tiers?.forEach(({ name }) => Object.assign(fields, $ai.getFieldsByTier(name)));
    return fields;
  }

  onLoad = (form) => {
    const { $moduleConfig } = this.props;
    $moduleConfig
      .fetchModuleConfig('ai')
      .then((config) => {
        const {
          deviceCommandAcls,
          companyPrompt,
          deviceConfigurationToolEnabled,
          deviceCommandToolEnabled,
          ...tierSettings
        } = config;
        form.init(tierSettings);
        this.setState({ loading: false });
      })
      // fetchModuleConfig already shows its own error toast; just stop the spinner.
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSubmit = (form, values) => {
    const { $moduleConfig, $credentials } = this.props;
    return $moduleConfig
      .fetchModuleConfig('ai', { force: true })
      .then((existingSettings) =>
        $moduleConfig.saveModuleConfig({
          module: 'ai',
          settings: { ...existingSettings, ...values }
        })
      )
      .then(() => {
        form.init(values);
        showSuccessToast('Updated Kentik AI settings successfully');
        return $credentials.groupedCollection.fetch({ force: true });
      });
  };

  get fallback() {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%" width="100%">
        <Spinner mb={4} flex={1} />
      </Flex>
    );
  }

  render() {
    const { $ai } = this.props;
    const { loading } = this.state;

    if ($ai.loading) {
      return this.fallback;
    }

    return (
      <FormComponent fields={this.fields} options={{ name: 'modelsAndCredentials' }} onLoad={this.onLoad}>
        {({ form }) => (
          <Suspense loading={loading} fallback={this.fallback}>
            <FlexColumn m={4} gap={4}>
              <Flex justifyContent="space-between" alignItems="center">
                <SettingsPanelHeading level={2} mb={0}>
                  Models &amp; Credentials
                </SettingsPanelHeading>
                {form && (
                  <FormActions
                    form={form}
                    onSubmit={this.handleSubmit}
                    showCancel={false}
                    closeAfterSave={false}
                    submitButtonProps={{ disabled: !form.dirty || !form.valid }}
                  />
                )}
              </Flex>
              {$ai.tiers?.map(({ name, description }) => (
                <ModelSettings key={name} tier={name} description={description} />
              ))}
            </FlexColumn>
          </Suspense>
        )}
      </FormComponent>
    );
  }
}

export default ModelsAndCredentials;
